import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import ListDataPod from '../../../components/ListDataPod';
import { makeFriendly } from '../../../utils/strings';

export const formatPoliciesList = importantPolicies => {
  const list = [];
  const admissionsPolicy = get(importantPolicies, 'admissionsPolicy.value', '');
  const earlyDecision = get(importantPolicies, 'earlyDecision.value', false);
  const notificationPolicy = get(importantPolicies, 'notificationPolicy.value', '');
  const registrationPolicy = get(importantPolicies, 'registrationPolicy.value', '');
  const waitingList = get(importantPolicies, 'waitingList.value', false);
  const testOptional = get(importantPolicies, 'testOptional.value', false);
  const formatPolicy = policy =>
    makeFriendly(policy)
      .replace(' Policy', '')
      .replace(/\./, '');

  if (admissionsPolicy && admissionsPolicy !== 'No admissions policy') {
    list.push(formatPolicy(admissionsPolicy));
  }

  if (earlyDecision) {
    list.push('Early Decision');
  } else {
    list.push('No Early Decision');
  }

  if (notificationPolicy && notificationPolicy !== 'No notification') {
    list.push(formatPolicy(notificationPolicy));
  }
  if (registrationPolicy && registrationPolicy !== 'No registration policy') {
    list.push(formatPolicy(registrationPolicy));
  }

  if (testOptional) {
    list.push('Test Optional');
  }

  if (waitingList) {
    list.push('Wait List');
  } else {
    list.push('No Wait List');
  }

  return list.sort();
};

export default function ImportantPolicies({ importantPolicies }) {
  const list = formatPoliciesList(importantPolicies);
  const emptyRe = /No Early Decision|No Wait List/;

  if (list.length === 2 && emptyRe.test(list[0]) && emptyRe.test(list[1])) {
    return null;
  }

  return (
    <ListDataPod
      header="Important Policies"
      content={{ list }}
      className="very-dark-gray"
    />
  );
}

ImportantPolicies.propTypes = {
  importantPolicies: PropTypes.object,
};
